import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "cart-drawer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Bestellung", -1)
const _hoisted_3 = { class: "items" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "item-image" }
const _hoisted_7 = { class: "square-image" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "item-details" }
const _hoisted_10 = { style: {"margin":"0"} }
const _hoisted_11 = { style: {"font-size":"1rem","margin":"0"} }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0"} }, "Add order photo?", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0"} }, "Your order is on the way!", -1)

import { setIntervalX } from '@/api/utils';
import store from '@/store'
import JSConfetti from 'js-confetti';
import { ref, reactive } from 'vue';
import AppModal from './AppModal.vue';
import PhotoBooth from './PhotoBooth.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartDrawer',
  setup(__props) {

const jsConfetti = new JSConfetti()
const audioWelcome = new Audio('/welcome.mp3')

const items = store.get(state => state.cart)

const state = reactive({
  ordering: false,
  showConfirmation: false,
  showPhotoBooth: false,
  timeout: 0,
  orderId: ''
})

const order = async () => {
  state.ordering = true
  state.orderId = await store.order() || ''
  state.showConfirmation = true
  state.ordering = false

  state.timeout = setTimeout(() => {
    store.signOut()
  }, 7000)
}

const addPhoto = () => {
  clearTimeout(state.timeout)
  audioWelcome.play()
  state.showPhotoBooth = true
  setIntervalX(() => {
    jsConfetti.addConfetti({
      //emojis: ['🌈', '⚡️', '💥', '✨', '💫', '⛷️'],
    })
  }, 1000, 6)
}

const onPhoto = (photo: string) => {
  if (state.orderId) {
    store.addOrderPhoto(state.orderId, photo)
    state.timeout = setTimeout(() => {
      store.signOut()
    }, 3000)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (!_unref(items).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4))
          : _createCommentVNode("", true),
        _createVNode(_TransitionGroup, { name: "item" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: item.id,
                onClick: ($event: any) => (_unref(store).removeFromCart(item))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: require(`@/assets/items/${item.id}.png`)
                    }, null, 8, _hoisted_8)
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h3", _hoisted_10, _toDisplayString(item.quantity) + " x " + _toDisplayString(item.name), 1),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(item.alias), 1)
                ])
              ], 8, _hoisted_5))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (order())),
        disabled: state.ordering
      }, "Bestellen", 8, _hoisted_12)
    ]),
    _createVNode(_Transition, { name: "slideUp" }, {
      default: _withCtx(() => [
        (state.showConfirmation)
          ? (_openBlock(), _createBlock(AppModal, { key: 0 }, {
              default: _withCtx(() => [
                _hoisted_13,
                _createElementVNode("button", {
                  onClick: addPhoto,
                  style: {"font-size":"3rem"}
                }, "JA!"),
                _hoisted_14
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slideUp" }, {
      default: _withCtx(() => [
        (state.showPhotoBooth)
          ? (_openBlock(), _createBlock(PhotoBooth, {
              key: 0,
              countdown: 5,
              onPhoto: onPhoto
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})